module.exports = __webpack_public_path__ + "static/media/galeryVinyl8.2f8ebab2.jpg";